import { useMemo } from 'react'
import { IntlProvider } from 'react-intl'
import { useLocalStorage } from 'usehooks-ts'

import { detectLanguage } from '@shared/utils'

import { messages } from '@utils/translations'

export default function LanguageProvider({ children }) {
  const [locale] = useLanguage()

  const currentLocale = useMemo(() => {
    if (locale) return locale
    return detectLanguage()
  }, [locale])

  const currentMessages = useMemo(() => messages[currentLocale] || messages.en, [currentLocale])

  return (
    <IntlProvider locale={currentLocale} messages={currentMessages} defaultLocale="en">
      {children}
    </IntlProvider>
  )
}

export const useLanguage = () => useLocalStorage('language', 'en')
